export const COMPONENT_NAME = 'CategoryListing';
